export default __webpack_public_path__ + "static/media/a1m.78cedbdd.png";